import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderTaxService } from '../order-tax.service';
import { OrderTax } from '../order-tax';

@Component({
    selector: 'app-order-tax',
    templateUrl: './order-tax.component.html',
    styleUrls: ['./order-tax.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderTaxComponent implements OnInit {
	chargeTypes: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private orderTaxService: OrderTaxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderTax = data.orderTax,
			this.statuses = orderTaxService.statuses;
			this.chargeTypes = orderTaxService.chargeTypes;
	}

	@Input() orderTax: OrderTax;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderTaxId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderTaxId': [],
		'name': [
			{ type: 'required', message: 'Required' }],
		'description': [],
		'status': [],
		'valueAMT': [],
		'valuePCT': [],
		'active': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole orderTax object
		if (this.orderTax) {
			this.orderTaxId = this.orderTax.orderTaxId;
			this.fixDates();
			this.form1.patchValue(this.orderTax);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderTaxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderTaxService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderTax = res.data.orderTax;
						this.doAdd.emit(this.orderTax);
					},
					(err: any) => {
						console.log('orderTax-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('orderTax: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderTaxService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderTax = res.data.tax;
						this.doUpdate.emit(this.orderTax);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderTaxService.delete(this.orderTax.orderTaxId)
				.subscribe(
					(res: any) => {
						console.log('orderTax-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderTax);
					},
					(err: any) => {
						console.log('orderTax-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderTaxId: [this.orderTaxId],
			name: ['', Validators.compose(
				[
					Validators.required
				])],
			description: [],
			status: [],
			valueAMT: [],
			valuePCT: [],
			active: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderTax.orderTaxDate = moment(this.orderTax.orderTaxDate).toDate();
	}
}
